export default "__VITE_ASSET__Be1AGg4m__"